import React, { useRef } from 'react';
import PropTypes from 'prop-types';
// for placing somewhere before mic is activated for earlier permission request
import { useEffectOnlyOnce } from '../../utility/EventHooks';

const DummyMicPermissionsComponent = () => {
  const micStream = useRef(null);

  useEffectOnlyOnce(() => {
    async function getMedia() {
      try {
        micStream.current = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
      } catch (err) {
        /* handle the error */
        console.error('Mic stream failed');
      }
    }

    getMedia();
    return () => {
      if (micStream.current) {
        micStream.current.getTracks().forEach((track) => {
          track.stop();
        });
      }
    };
  });
  return <></>;
};

DummyMicPermissionsComponent.propTypes = {};

export default DummyMicPermissionsComponent;
